import React from 'react';
import LadingPage from '../LandingPage';
import ViewRateTable from './ViewRateTable';

function RateTable() {
  return (
    <>
      <LadingPage>
        <div className="dash-board">
          <ViewRateTable />
        </div>
      </LadingPage>
    </>
  );
}

export default RateTable;
